/* eslint-disable */
export default {
  inAMeeting: 'Tapaamisessa',
  onMyWay: 'Olen tulossa',
  callMeBackIn: 'Soita takaisin, kun on kulunut...',
  willCallYouBackIn: 'Soitan takaisin, kun on kulunut...',
  hour: 'tunti',
  min: 'min',
} as const;

// @key: @#@"inAMeeting"@#@ @source: @#@"In a meeting"@#@
// @key: @#@"onMyWay"@#@ @source: @#@"On my way"@#@
// @key: @#@"callMeBackIn"@#@ @source: @#@"Call me back in..."@#@
// @key: @#@"willCallYouBackIn"@#@ @source: @#@"Will call you back in..."@#@
// @key: @#@"hour"@#@ @source: @#@"hour"@#@
// @key: @#@"min"@#@ @source: @#@"min"@#@
